import React from 'react';
import { ViewButton, EditButton } from '../Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabels,
  getSort,
} from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (
  openViewModal,
  openEditModal,
  acquisitionOrders,
  user,
  countryId,
) => [
  {
    title: 'ID',
    name: 'id',
    hidden: true,
  },
  {
    title: 'Display Name',
    name: 'displayName',
    width: 150,
    sort: true,
  },
  {
    title: 'Role',
    name: 'role',
    width: 120,
    sort: true,
  },
  {
    title: 'Exchange Number',
    name: 'phoneExchangeId',
    width: 150,
    sort: true,
  },
  {
    title: 'Acquisition Orders',
    name: 'acquisitionOrderIds',
    formatterComponent: ({ value }) => getLabels(value, acquisitionOrders),
    sorting: (a, b) =>
      getSort(getLabels(a, acquisitionOrders), getLabels(b, acquisitionOrders)),
    filter: (value, filter) =>
      getFilter(getLabels(value, acquisitionOrders), filter.value),
  },
  {
    title: 'Active',
    name: 'active',
    width: 100,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-danger font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'yes' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'yes' : 'no', b ? 'yes' : 'no'),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => `${moment(value).fromNow()}`,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
  },
  {
    title: 'Action',
    name: 'action',
    width: 120,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        {(user.role !== row.role || user.id === row.id) && (
          <EditButton row={row} onPress={openEditModal} />
        )}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
